module.exports = __webpack_public_path__ + "static/media/css.d20db6d3.svg";